import { render } from "./BaTabs.vue?vue&type=template&id=1b4146f8&scoped=true&ts=true"
import script from "./BaTabs.vue?vue&type=script&lang=ts"
export * from "./BaTabs.vue?vue&type=script&lang=ts"

import "./BaTabs.vue?vue&type=style&index=0&id=1b4146f8&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4146f8"]])

export default __exports__